import { render } from "./QrCodeScanner.vue?vue&type=template&id=8995a0a8&scoped=true"
import script from "./QrCodeScanner.vue?vue&type=script&lang=js"
export * from "./QrCodeScanner.vue?vue&type=script&lang=js"

import "./QrCodeScanner.vue?vue&type=style&index=0&id=8995a0a8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8995a0a8"]])

export default __exports__